import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const TaskPanel = ({ tasks, onTaskComplete }) => {
  const [filter, setFilter] = useState('all');

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high':
        return 'AlertCircle';
      case 'medium':
        return 'AlertTriangle';
      case 'low':
        return 'Info';
      default:
        return 'Circle';
    }
  };

  const filteredTasks = filter === 'all' 
    ? tasks 
    : tasks?.filter(task => !task?.completed);

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Tasks & Alerts</h2>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setFilter('all')}
            className={`px-3 py-1.5 text-sm rounded-lg transition-colors ${
              filter === 'all' ?'bg-primary text-primary-foreground' :'bg-muted text-foreground hover:bg-muted/80'
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilter('pending')}
            className={`px-3 py-1.5 text-sm rounded-lg transition-colors ${
              filter === 'pending' ?'bg-primary text-primary-foreground' :'bg-muted text-foreground hover:bg-muted/80'
            }`}
          >
            Pending
          </button>
        </div>
      </div>
      <div className="space-y-3 max-h-[400px] overflow-y-auto custom-scrollbar">
        {filteredTasks?.map((task) => (
          <div
            key={task?.id}
            className={`p-4 rounded-lg border transition-all ${
              task?.completed 
                ? 'bg-muted/30 border-border opacity-60' :'bg-card border-border hover:border-primary/50'
            }`}
          >
            <div className="flex items-start gap-3">
              <button
                onClick={() => onTaskComplete(task?.id)}
                className={`mt-1 w-5 h-5 rounded border-2 flex items-center justify-center transition-all focus-ring ${
                  task?.completed
                    ? 'bg-success border-success' :'border-muted-foreground hover:border-primary'
                }`}
              >
                {task?.completed && <Icon name="Check" size={14} color="white" />}
              </button>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className={`text-sm font-medium ${
                    task?.completed ? 'line-through text-muted-foreground' : 'text-foreground'
                  }`}>
                    {task?.title}
                  </h3>
                  <Icon 
                    name={getPriorityIcon(task?.priority)} 
                    size={16} 
                    className={getPriorityColor(task?.priority)}
                  />
                </div>
                <p className="text-sm text-muted-foreground mb-2">{task?.description}</p>
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Clock" size={12} />
                    {task?.dueTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Tag" size={12} />
                    {task?.category}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filteredTasks?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="CheckCircle2" size={48} color="var(--color-success)" />
          <p className="mt-3 text-sm text-muted-foreground">All tasks completed!</p>
        </div>
      )}
    </div>
  );
};

export default TaskPanel;